<template>
  <div class="banners mt-3">
    <b-row v-if="staffName" class="my-1">
      <b-col lg="12">
        <b-form-group
          class="font-weight-bold"
          label-cols-lg="auto"
          label="Numer licencji"
          label-for="lic"
        >
          <b-form-input id="lic" v-model="licence" disabled></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <a
      v-if="
        program === 'skp' &&
        showNewYearBanners &&
        !isTestAccountRegistered &&
        !isTestAccountUnregistered
      "
      :href="orderOsLink"
      target="_blank"
    >
      <img :src="styles.banner_opieka" alt="check" class="py-1" />
    </a>
    <a
      v-if="
        showNewYearBanners &&
        !isTestAccountRegistered &&
        !isTestAccountUnregistered
      "
      :href="changeYearLink"
      target="_blank"
      ><img :src="styles.banner_rok" alt="check" class="py-1"
    /></a>
    <a
      v-if="
        program === 'skp' &&
        !isAccountant &&
        !isTestAccountUnregistered &&
        !isTestAccountRegistered
      "
      href="https://www.mojeskp24.pl/?ref=baner-mk-firma_2025"
      target="_blank"
    >
      <img :src="styles.banner_firma" alt="check" class="py-1" />
    </a>
    <a
      v-if="
        program === 'skp' &&
        isAccountant &&
        !isTestAccountUnregistered &&
        !isTestAccountRegistered
      "
      href="https://www.mojeskp24.pl/?ref=baner-mk-biuro_2025"
      target="_blank"
    >
      <img :src="styles.banner_biuro" alt="check" class="py-1" />
    </a>
    <a
      v-if="
        program === 'skp' &&
        bannerBon &&
        (isTestAccountRegistered || isTestAccountUnregistered)
      "
      href="https://www.ksiega-podatkowa.pl/zamowienie?ordProm=4&ref=baner_mk_testowa"
      target="_blank"
    >
      <img :src="styles.banner_bon" alt="check" class="py-1" />
    </a>

    <a
      v-if="
        program === 'sam' &&
        !isTestAccountRegistered &&
        !isTestAccountUnregistered
      "
      href="https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/zmiana-sam-na-skp-2022"
      target="_blank"
    >
      <img :src="styles.zmiana_sam_na_skp_2022" alt="check" class="py-1" />
    </a>
    <a v-if="program === 'skp'" :href="faqLink" target="_blank">
      <img :src="styles.banner_faq" alt="check" class="py-1" />
    </a>
    <a
      v-if="
        program === 'skp' &&
        (isTestAccountRegistered || isTestAccountUnregistered)
      "
      href="https://www.ksiega-podatkowa.pl/zamowienie?ordProm=8"
      target="_blank"
    >
      <img :src="styles.banner_15_skp" alt="check" class="py-1" />
    </a>
    <a
      v-if="!isTestAccountRegistered && !isTestAccountUnregistered && banner50"
      :href="orderLink"
      ><img :src="styles.banner_50" alt="check" class="py-1"
    /></a>
    <a
      v-if="
        !isTestAccountRegistered &&
        !isTestAccountUnregistered &&
        banner30_skp_sam &&
        program === 'skp'
      "
      :href="orderLink"
      ><img :src="styles.banner_30_skp" alt="check" class="py-1"
    /></a>
    <a
      v-if="
        !isTestAccountRegistered &&
        !isTestAccountUnregistered &&
        banner_course_0 &&
        !hasCourseAccess &&
        program === 'skp'
      "
      :href="orderLink"
      ><img :src="styles.banner_course_0" alt="check" class="py-1"
    /></a>
    <a
      v-if="
        !isTestAccountRegistered &&
        !isTestAccountUnregistered &&
        banner30_skp_sam &&
        program === 'sam'
      "
      :href="orderLink"
      ><img :src="styles.banner_30_sam" alt="check" class="py-1"
    /></a>

    <a
      v-if="
        program === 'skp' &&
        !isTestAccountRegistered &&
        !isTestAccountUnregistered
      "
      target="_blank"
      :href="recommendAFriendLink"
    >
      <img :src="styles.banner_polec" alt="check" class="py-1" />
    </a>
    <a
      target="_blank"
      href="https://www.ksiega-podatkowa.pl/opinie-rekomendacje-referencje?ref=Baner_MK_2025"
    >
      <img :src="styles.skp_ocena" alt="check" class="py-1" />
    </a>
    <a
      v-if="program === 'skp'"
      href="https://www.ksiega-podatkowa.pl/akademia-skp/zamowienie-programu-raty-payu?ref=Baner_MK_2025"
      target="_blank"
    >
      <img :src="styles.banner_raty" alt="check" class="py-1" />
    </a>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'Banners',
  props: {
    styles: {},
    program: {},
    hasCourseAccess: {},
  },
  data: function () {
    return {
      year: process.env.MIX_AKTU_YEAR,
    };
  },
  computed: {
    ...mapGetters({
      licence: 'auth/userLicence',
      client: 'auth/client',
      currentOs: 'auth/currentOs',
      isTestAccountRegistered: 'auth/isTestAccountRegistered',
      isTestAccountUnregistered: 'auth/isTestAccountunRegistered',
    }),
    staffName() {
      return localStorage.getItem('staffName');
    },
    isAccountant() {
      return (
        this.client.MDS !== null &&
        this.client.MDS !== '' &&
        this.client.MDS.split('').includes('B')
      );
    },
    changeYearLink() {
      if (
        this.client.MDS !== null &&
        this.client.MDS !== '' &&
        this.client.MDS.split('').includes('S')
      ) {
        return 'https://www.ksiega-podatkowa.pl/akademia-skp/zmiana-roku-wersja-sieciowa?ref=baner_mk_skp_2025';
      } else {
        return this.program === 'skp'
          ? 'https://www.ksiega-podatkowa.pl/akademia-skp/zmiana-roku-wersja-sieciowa?ref=baner_mk_skp_2025'
          : 'https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/zmiana-roku?ref=baner_mk_sam_2022';
      }
    },
    orderOsLink() {
      return this.program === 'skp'
        ? 'https://www.ksiega-podatkowa.pl/akademia-skp/zamowienie-opieki-serwisowej?ref=baner_mk_skp_2025'
        : 'https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/opieka-serwisowa-zamowienie-kroki?ref=baner_mk_sam_2022';
    },
    faqLink() {
      return this.program === 'skp'
        ? 'https://www.ksiega-podatkowa.pl/akademia-skp/?ref=baner_mk_skp_2025'
        : 'https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/faq?ref=baner_mk_sam_2022';
    },
    recommendAFriendLink() {
      return this.program === 'skp'
        ? 'https://www.ksiega-podatkowa.pl/promocje-skp/polec-znajomemu?ref=baner_mk_skp_2025'
        : 'https://www.samozatrudnienie.pl/promocje/polec-znajomemu?ref=baner_mk_sam_06_2022';
    },
    bannerBon() {
      return (
        moment().format('YYYY-MM-DD HH:mm:ss') > '2024-05-13 08:00:00' &&
        moment().format('YYYY-MM-DD HH:mm:ss') <= '2024-05-31 23:59:59'
      );
    },
    banner50() {
      return (
        moment().format('YYYY-MM-DD HH:mm:ss') > '2021-07-26 10:00:00' &&
        moment().format('YYYY-MM-DD HH:mm:ss') <= '2021-08-10 23:59:59' &&
        this.currentOs
      );
    },
    banner30_skp_sam() {
      return (
        moment().format('YYYY-MM-DD HH:mm:ss') > '2021-08-09 12:00:00' &&
        moment().format('YYYY-MM-DD HH:mm:ss') <= '2021-08-30 23:59:59' &&
        !this.currentOs
      );
    },
    banner_course_0() {
      return (
        moment().format('YYYY-MM-DD HH:mm:ss') > '2022-05-09 12:00:00' &&
        moment().format('YYYY-MM-DD HH:mm:ss') <= '2022-08-31 23:59:59' &&
        this.currentOs
      );
    },
    orderLink() {
      return this.program === 'skp' ? '/skp/zamowienie' : '/sam/zamowienie';
    },
    showNewYearBanners() {
      return !this.currentOs || this.year > moment().year();
    },
  },
};
</script>

<style scoped></style>
